import { render, staticRenderFns } from "./LocationCardDetails.vue?vue&type=template&id=1fdc014c"
import script from "./LocationCardDetails.vue?vue&type=script&lang=js"
export * from "./LocationCardDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports